import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { SKIPPER_AUTHOR_ID } from '../../const'
import { API_COMMAND_ENDPOINT } from './const'
import { SharedAssistantState, CommandParams } from './types'

const THINKING_PATTERN = /^(\.{3}|Thinking\.{3})$/

/**
 * Cancels the current Skipper response by immediately removing the thinking message
 * from the UI and sending the response_cancel command to the backend.
 */
export default async function cancelResponse<T extends SharedAssistantState>({
  assistantState,
  update,
  awaitContext,
  debugName = 'ChatAssistant'
}: CommandParams<T>): Promise<void> {
  // Optimistic UI update: remove thinking message and unlock input immediately
  assistantState.messages = assistantState.messages.filter(
    message => !(message.author === SKIPPER_AUTHOR_ID && THINKING_PATTERN.test(message.text.trim()))
  )
  assistantState.inputReady = true
  update()

  // Send backend command in the background
  try {
    const commandContext = await awaitContext({ assistantState })
    const commandParams = {
      domain: assistantState.domain,
      command: 'response_cancel',
      payload: {},
      ids: assistantState.messages.map(m => m.id),
      context: commandContext
    }

    await railsPostFetch(API_COMMAND_ENDPOINT.URL.replace('{chatID}', String(assistantState.chatID)), {
      method: API_COMMAND_ENDPOINT.method,
      body: JSON.stringify(commandParams)
    })
  } catch (error) {
    if ('development' === process.env.NODE_ENV) {
      // eslint-disable-next-line no-console
      console.error(`${debugName}: cancelResponse error`, error)
    }
  }
}
